import type { ISPMetrics } from '@/api/hooks/use-analytics'
import { DataTable } from '@/components/ui/data-table'
import { StatusBadge } from '@/components/ui/status-badge'

const GOOD_DELIVERY_RATE = 98
const WARNING_DELIVERY_RATE = 95

interface ISPBreakdownTableProps {
  data: ISPMetrics[]
}

export function ISPBreakdownTable({ data }: ISPBreakdownTableProps): React.JSX.Element {
  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <div className="mb-4">
        <h3 className="text-sm font-medium text-text-primary">ISP Breakdown</h3>
        <p className="text-xs text-text-tertiary">Performance by recipient mail provider</p>
      </div>
      <DataTable
        columns={[
          {
            key: 'domain',
            label: 'ISP',
            render: (row) => <span className="font-medium">{row.domain}</span>,
          },
          {
            key: 'sent',
            label: 'Sent',
            sortable: true,
            render: (row) => formatNumber(row.sent),
          },
          {
            key: 'delivered',
            label: 'Delivered',
            sortable: true,
            render: (row) => formatNumber(row.delivered),
          },
          {
            key: 'delivery_rate',
            label: 'Delivery Rate',
            sortable: true,
            render: (row) => (
              <StatusBadge
                status={
                  row.delivery_rate >= GOOD_DELIVERY_RATE
                    ? 'good'
                    : row.delivery_rate >= WARNING_DELIVERY_RATE
                      ? 'warning'
                      : 'bad'
                }
              >
                {row.delivery_rate.toFixed(1)}%
              </StatusBadge>
            ),
          },
          {
            key: 'open_rate',
            label: 'Open Rate',
            sortable: true,
            render: (row) => `${row.open_rate.toFixed(1)}%`,
          },
        ]}
        data={data}
        emptyMessage="No ISP data available for this period."
      />
    </div>
  )
}

function formatNumber(n: number): string {
  return n.toLocaleString()
}
